import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { inventoryAPI } from '../../services';
import { toast } from 'react-toastify';

const emptyForm = {
  name: '',
  phone: '',
  zalo_phone: '',
  note: '',
  is_active: true,
};

export default function SupplierFormModal({ show, onHide, supplier, onSuccess }) {
  const [formData, setFormData] = useState(emptyForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (supplier) {
      setFormData({
        name: supplier.name || '',
        phone: supplier.phone || '',
        zalo_phone: supplier.zalo_phone || '',
        note: supplier.note || '',
        is_active: supplier.is_active !== false,
      });
    } else {
      setFormData(emptyForm);
    }
  }, [supplier, show]);

  const handleChange = (field, value) =>
    setFormData((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      toast.error('Vui lòng nhập tên nhà cung cấp');
      return;
    }
    try {
      setLoading(true);
      const data = {
        name: formData.name.trim(),
        phone: formData.phone.trim() || undefined,
        // Chuỗi rỗng phải gửi lên để XOÁ được SĐT Zalo đã lưu (undefined thì BE bỏ qua, xoá không ăn)
        zalo_phone: supplier ? formData.zalo_phone.trim() : (formData.zalo_phone.trim() || undefined),
        note: formData.note.trim() || undefined,
        is_active: formData.is_active,
      };
      if (supplier) {
        await inventoryAPI.updateSupplier(supplier.id, data);
        toast.success('Đã cập nhật nhà cung cấp');
      } else {
        await inventoryAPI.createSupplier(data);
        toast.success('Đã tạo nhà cung cấp mới');
      }
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(err?.message || 'Không thể lưu nhà cung cấp');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{supplier ? 'Sửa nhà cung cấp' : 'Thêm nhà cung cấp'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Tên nhà cung cấp <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              value={formData.name}
              onChange={(e) => handleChange('name', e.target.value)}
              placeholder="VD: Công ty ABC"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Số điện thoại</Form.Label>
            <Form.Control
              type="tel"
              value={formData.phone}
              onChange={(e) => handleChange('phone', e.target.value)}
              placeholder="0xxxxxxxxx"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>SĐT Zalo (để gửi đơn đặt hàng)</Form.Label>
            <Form.Control
              type="tel"
              value={formData.zalo_phone}
              onChange={(e) => handleChange('zalo_phone', e.target.value)}
              placeholder="0xxxxxxxxx"
            />
            <Form.Text className="text-muted">
              Số này nhận tin nhắn đơn đặt hàng qua Zalo. Bỏ trống thì không gửi đơn qua Zalo được.
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Ghi chú</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={formData.note}
              onChange={(e) => handleChange('note', e.target.value)}
              placeholder="Thông tin thêm về nhà cung cấp..."
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              label="Đang hoạt động"
              checked={formData.is_active}
              onChange={(e) => handleChange('is_active', e.target.checked)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>Hủy</Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Đang lưu...' : supplier ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
